import BlogHero from "../../../../components/general/blog/BlogHero/BlogHero";
import FeaturedPost from "../../../../components/general/blog/FeaturedPost/FeaturedPost";
import BlogGrid from "../../../../components/general/blog/BlogGrid/BlogGrid";
import MentorSpotlight from "../../../../components/general/blog/MentorSpotlight/MentorSpotlight";
import NewsletterSection from "../../../../components/general/blog/NewsLetterSection/NewsLetterSection";

const BlogPage = () => {
  return (
    <div className="blog-main-page">
      <BlogHero />
      <FeaturedPost />
      <BlogGrid />
      <MentorSpotlight />
      <NewsletterSection />
    </div>
  );
};

export default BlogPage;
